export const listMutations = <const>{
	TABULKOVA_POZICE_SELECT_MAPPER: 'TABULKOVA_POZICE_SELECT_MAPPER',
};

export const editActions = <const>{
	SERVISNI_PAKETY_DRUH: 'SERVISNI_PAKETY_DRUH',
};

export const editMutations = <const>{
	TABULKOVA_POZICE_SELECT_MAPPER_EDIT: 'TABULKOVA_POZICE_SELECT_MAPPER_EDIT',
};
